<template>
  <button class="dropzone__btn--cardPreview">
    <slot name="icon">
      <i class="fas fa-plus"></i>
    </slot>
  </button>
</template>
